import { render, staticRenderFns } from "./BandResTemplate.vue?vue&type=template&id=519946a0"
import script from "./BandResTemplate.vue?vue&type=script&lang=js"
export * from "./BandResTemplate.vue?vue&type=script&lang=js"
import style0 from "./BandResTemplate.vue?vue&type=style&index=0&id=519946a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports